import Vue from 'vue'
import VueRouter from 'vue-router'
// import { getToken } from '@/axios/utils.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView1.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/IndexView.vue')
  },
  {
    path: '/home',
    name: 'anotherHome',
    component: () => import('@/views/IndexView.vue'),
    children: [
      {
        path: '/product-management',
        name: 'product-management',
        component: () => import('@/views/product/product-management.vue')
      },
      {
        path: '/device-management',
        name: 'device-management',
        component: () => import('@/views/device/device-management.vue')
      },
      {
        path: '/device-management/detail',
        name: 'device-management/detail',
        component: () => import('@/views/device/device-detail.vue')
      },
      {
        path: '/device-management/pav-detail',
        name: 'device-management/pav-detail',
        component: () => import('@/views/device/paving/pav-device-detail.vue')
      },
      {
        path: '/device-management/caterpillar-detail',
        name: 'device-management/caterpillar-detail',
        component: () => import('@/views/device/caterpillar/caterpillar-device-detail.vue')
      },
      {
        path: '/location-management',
        name: 'location-management',
        component: () => import('@/views/location/location-management.vue')
      },
      {
        path: '/data-statistic',
        name: 'data-statistic',
        component: () => import('@/views/statistic/data-statistic.vue')
      },
      //   {
      //     path: '/fault-diagnosis',
      //     name: 'fault-diagnosis',
      //     component: () => import('@/views/body/fault/fault-diagnosis.vue')
      //   },
      {
        path: '/run-log',
        name: 'run-log',
        component: () => import('@/views/run/run-log.vue')
      },
      {
        path: '/share-management',
        name: 'share-management',
        component: () => import('@/views/share/share-management.vue')
      },
      {
        path: '/parameter-setting',
        name: 'parameter-setting',
        component: () => import('@/views/parameter/parameter-setting.vue')
      },
      {
        path: '/version-management',
        name: 'version-management',
        component: () => import('@/views/VersionManagement.vue')
      },
      {
        path: '/company-management',
        name: 'companyManagement',
        component: () => import('@/views/company/companyManage.vue')
      },
      // {
      //   path: '/user-management',
      //   name: 'user-management',
      //   component: () => import('@/views/userList/user-list.vue')
      // },
      {
        path: '/accounts-management',
        name: 'accounts-management',
        component: () => import('@/views/accountsList/accounts-list.vue')
      },
      {
        path: '/dispatch-management',
        name: 'dispatch-management',
        component: () => import('@/views/dispatch/dispatch-management.vue')
      }
    ]
  },
  {
    path: '/data-view',
    name: 'data',
    component: () => import('@/views/datav/DataView.vue')
  },
  {
    path: '/login-direct',
    name: 'login-direct',
    component: () => import('@/views/Login-direct.vue')
  }
  // {
  //   path: '*',
  //   name: 'NotFound',
  //   component: NotFound
  // }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// const FRONT_PAGE = ['login']
// router.beforeEach((to, from, next) => {
//   const arr = FRONT_PAGE.filter((item) => { return item === to.name })
//   if (getToken()) {
//     if (to.path === '/login') {
//       next()
//     } else {
//       next('/')
//     }
//   } else {
//     next('/login')
//   }
// })
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
